module.exports = __webpack_public_path__ + "static/media/icon-calendar-white.2861d062.svg";